import Gradient from '../../lib/stripe-gradient/Gradient';

export function gradient(page) {
	/*--------------------------------
	グラデーション
	--------------------------------*/
	const gradient01 = new Gradient({
		canvas: '#canvas01',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

	const gradient02 = new Gradient({
		canvas: '#canvas02',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

	const gradient03 = new Gradient({
		canvas: '#canvas03',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

	const gradient04 = new Gradient({
		canvas: '#canvas04',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});
	const gradient05 = new Gradient({
		canvas: '#canvas05',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

	const gradient06 = new Gradient({
		canvas: '#canvas06',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});
	const gradient07 = new Gradient({
		canvas: '#canvas07',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

}
